import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

import useSystemOptionsStore from 'src/stores/systemOptionsStore';

interface Props {
  selectedYear: number | null;
  onYearChange: (year: number | null) => void;
  allowAllYears?: boolean;
  id?: string;
  minWidth?: number;
  fullWidth?: boolean;
}

export default function EditionYearFilter({
  selectedYear,
  onYearChange,
  allowAllYears = false,
  id = 'edition-year-filter',
  minWidth = 120,
  fullWidth = false,
}: Props) {
  const { t } = useTranslation();
  const { editions } = useSystemOptionsStore(s => s);

  return (
    <FormControl size="small" sx={{ minWidth, ...(fullWidth ? { width: '100%' } : {}) }}>
      <InputLabel id={`${id}-label`} shrink>
        {t('editions.edition')}
      </InputLabel>
      <Select
        labelId={`${id}-label`}
        value={selectedYear ?? ''}
        label={t('editions.edition')}
        onChange={e => {
          const value = e.target.value as number | '';
          onYearChange(value === '' ? null : Number(value));
        }}
        displayEmpty={allowAllYears}
        renderValue={() => {
          if (selectedYear == null) {
            return allowAllYears ? t('base.all') : '';
          }
          return String(selectedYear);
        }}
      >
        {allowAllYears ? <MenuItem value="">{t('base.all')}</MenuItem> : null}
        {editions?.map(edition => (
          <MenuItem key={edition.id} value={edition.year}>
            {edition.year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
